import React from "react";
import StatusBadge from "../../../components/common/StatusBadge";

// Warranty status is computed server-side from dates at read time and never stored,
// so this badge only renders what the API already decided - it does no date maths of
// its own, which is what keeps the web and any future mobile view from disagreeing.
const CLASS_MAP = {
  ACTIVE: "badge-linesuccess",
  EXPIRED: "badge-linedanger",
  NA: "badge-linedark",
};

const LABEL_MAP = {
  ACTIVE: "Active",
  EXPIRED: "Expired",
  NA: "Not applicable",
};

const WarrantyBadge = ({ status, daysRemaining }) => {
  // Under three months left is the point where somebody should be acting on it, so it
  // reads as a warning rather than a healthy green.
  const isExpiringSoon = status === "ACTIVE" && daysRemaining != null && daysRemaining <= 90;

  return (
    <span className="d-inline-flex align-items-center gap-2">
      <StatusBadge
        status={status}
        classMap={{ ...CLASS_MAP, ...(isExpiringSoon ? { ACTIVE: "badge-linewarning" } : {}) }}
        labelMap={LABEL_MAP}
      />
      {status === "ACTIVE" && daysRemaining != null && (
        <small className={isExpiringSoon ? "text-warning" : "text-muted"}>
          {daysRemaining} day{daysRemaining === 1 ? "" : "s"} left
        </small>
      )}
    </span>
  );
};

export default WarrantyBadge;
